import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';
import ModelDataSourcePropertyBase from "./ModelDataSourcePropertyBase";
import ModelDataSourceServiceOtherParamsProperty from "./ModelDataSourceServiceOtherParamsProperty";

import { FetchHelper } from "@yulintu/freesia-core";

import { parseQueryResultToCommonResult } from '../utils/helper';

import ModelDataSourceServiceParamProperty from "./ModelDataSourceServiceParamProperty";

export default class Model extends ModelDataSourcePropertyBase {

    urlType = new PropertyDescriptor('static', '地址类型', "高级", "enum", "#anticon-chuangkou", {
        values: [
            new PropertyDescriptor("static", "静态地址"),
            new PropertyDescriptor("custom", "表达式"),
        ],
    });

    url = new PropertyDescriptor('https://randomuser.me/api', '服务地址', '高级', 'text', "#anticon-link", {
        style: { fontSize: 13 },
    });

    urlExpression = new PropertyDescriptor('`https://randomuser.me/api`', '服务地址', '高级', 'js', "#anticon-Documentation", {
        visible: false,
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    type = new PropertyDescriptor('GET', '请求类型', "高级", "enum", "#anticon-speed", {
        values: [
            new PropertyDescriptor("GET"),
            new PropertyDescriptor("POST"),
            new PropertyDescriptor("PUT"),
            new PropertyDescriptor("DELETE"),
        ],
    });

    params = new PropertyDescriptor([new ModelDataSourceServiceParamProperty({
        name: "results",
        expression: "10",
    })], '请求数据', "高级", "objects", "#anticon-jichubiaoge", {
        description: "配置请求网络服务的时要传入的数据",
        modelTemplate: ModelDataSourceServiceParamProperty,
    });

    others = new PropertyDescriptor(new ModelDataSourceServiceOtherParamsProperty(), '其他设置', "高级", "object", "#anticon-profile-setting", {
        valueTemplate: ModelDataSourceServiceOtherParamsProperty,
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
        this.resetVisible();
    }

    onPropertyValueChanged(name, valOld, valNew, subName, args) {

        if (name === "urlType") {
            this.resetVisible();
        }
    }

    resetVisible() {
        this.setPropertyVisible("url", this.urlType === "static");
        this.setPropertyVisible("urlExpression", this.urlType === "custom");
    }

    getUrl(opts) {
        if (this.urlType === "static")
            return this.url;

        const url = opts.runScript(this.urlExpression, opts.data, undefined, undefined, { throwException: true });
        return url;
    }

    loadData(opts) {
        return new Promise((resolve, reject) => {

            const url = this.getUrl(opts);
            if (!url) {
                resolve(null);
                return;
            }
            let params = {};
            (this.params || []).forEach(param => {
                params[param.name] = param.getValue({ runScript: opts.runScript });
            });

            let fetchParams = this.others.getFetchParams({ runScript: opts.runScript });

            let api = this.getMethod();
            api(url, params, fetchParams)
                .then(baseData => {
                    let results = this.others.getResults(baseData, { runScript: opts.runScript, lastData: opts.lastData });
                    let data = parseQueryResultToCommonResult(results);
                    resolve(data);
                    // resolve(data);

                }).catch(err => {
                    reject(err);
                })
        })
    }

    getMethod() {
        const type = this.type;
        if (type === "GET")
            return FetchHelper.getJson.bind(FetchHelper);
        if (type === "POST")
            return FetchHelper.postJson.bind(FetchHelper);
        if (type === "PUT")
            return FetchHelper.putJson.bind(FetchHelper);
        if (type === "DELETE")
            return FetchHelper.deleteJson.bind(FetchHelper);
    }
}
